import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'XS' | 'S' | 'M' | 'L';

export const enum FilledFlavor {
	DEFAULT = 'DEFAULT',
	WARNING = 'WARNING',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	XS: 'p-1-r p-2-l p-0h-tb br-0t fl-gap-0h',
	S: 'p-1h-r p-2-l p-0t-tb br-1 fl-gap-0t',
	M: 'p-2-rl p-1-tb br-1 fl-gap-1',
	L: 'p-2-rl p-1-tb br-1 fl-gap-1',
};

@Directive({
	selector: '[buttonOutlined]',
	standalone: true,
	host: {
		class: 'fl fl-ai-c fl-jc-c fc-400 fs-m bordered',
		'[class.bg-standard-hover-on-hover]': '!$disabled()',
		'[class.border-230]': '!$disabled()',
		'[class.fc-800]': '!$disabled() && $flavorIsDefault()',
		'[class.border-250]': '$disabled()',
		'[class.fc-warn]': '!$disabled() && $flavorIsWarning()',
		'[class.border-warn]': '!$disabled() && $flavorIsWarning()',
		'[class.fc-200]': '$disabled()',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms, border-color: 300ms;',
	},
})
export class ButtonOutlinedDirective {
	public readonly $size = input<ButtonSize>('M', { alias: 'size' });
	public readonly $flavor = input<FilledFlavor | `${FilledFlavor}`>(FilledFlavor.DEFAULT, {
		alias: 'flavor',
	});

	protected readonly $flavorIsWarning = computed(() => {
		return this.$flavor() === FilledFlavor.WARNING;
	});

	public readonly $flavorIsDefault = computed(() => {
		return this.$flavor() === FilledFlavor.DEFAULT;
	});

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});
}
